import { differenceInCalendarYears } from 'date-fns'
import { GetProfileResponseType, SteamUserDataType } from '@/entities/user'

// const useEgsDataResponse = (data: GetProfileResponseType) => {
//   let userData: EpicUserDataResponseType
//   if (data.epic_data === null) {
//     userData = {
//       username: null,
//       total_xp: null,
//       total_achievements: null,
//       games: [],
//       scoring_diff: {
//         games_owned: null,
//         games_owned_token: null,
//         achievements: null,
//         achievements_token: null,
//         xp: null,
//         xp_token: null,
//       },
//     }
//     return userData
//   }
//   userData = {
//     username: data.epic_data.username,
//     total_xp: data.epic_data.total_xp,
//     total_achievements: data.epic_data.total_achievements,
//     games: data.epic_data.games,
//     scoring_diff: {
//       games_owned: data.epic_data.scoring_diff.games_owned,
//       games_owned_token: data.epic_data.scoring_diff.games_owned_token,
//       achievements: data.epic_data.scoring_diff.achievements,
//       achievements_token: data.epic_data.scoring_diff.achievements_token,
//       xp: data.epic_data.scoring_diff.xp,
//       xp_token: data.epic_data.scoring_diff.xp_token,
//     },
//   }
//   return userData
// }

const useSteamDataResponse = (data: GetProfileResponseType) => {
  if (data.steam_data === null) {
    const userData: SteamUserDataType = {
      itemsList: null,
      gamesList: null,
      userData: {
        gamed_id: data.user.gamed_id ? data.user.gamed_id : null,
        id: null,
        name: data.user.first_name ? data.user.first_name : null,
        photoUrl: data.user.photo_url ? data.user.photo_url : null,
        totalValue: null,
        epicTotalValue: null,
        diff_games_count: null,
        diff_total_hours: null,
        diff_items_count: null,
        diff_total_value_usd: null,
        epic_token_value: null,
        gamesOwned: null,
        totalHoursPlayed: null,
        itemsOwned: null,
        inventoryPrice: null,
        accountAge: null,
        nextSteamUpdateUnlockDate: null,
        tokenValue: data.user.token_value ? data.user.token_value : null,
        steamId: null,
        ref_url: data.user.ref_url ? data.user.ref_url : null,
        ref_url_story: data.user.ref_url_story ? data.user.ref_url_story : null,
        gamed_premium_until: data.user.gamed_premium_until ? data.user.gamed_premium_until : null,
        level_premium: data.user.level_premium ? data.user.level_premium : null,
        favoriteGame: null,
        profile_private: false,
        previous_token_value_total: data.user.previous_token_value_total,
        registredAt: null,
        gigi_index: null,
        farcana_gigi: null,
        epic_id: null,
        epic_update_in_progress: false,
        steam_update_in_progress: false,
        next_epic_update_unlocked: null,
      },
      referal_info: data.referral_info,
      scoring_diff: null,
      settings: {},
    }

    return userData
  }

  const steamUserData: SteamUserDataType = {
    itemsList: data.steam_data.top_items,
    gamesList: data.steam_data.games,
    userData: {
      id: data.user.steam_id,
      gamed_id: data.user.gamed_id,
      name: data.steam_data.profile.name,
      photoUrl: data.steam_data.profile.photo_url,
      totalValue: data.steam_data.profile.total_value_usd,
      epicTotalValue: data?.epic_data?.total_value_usd ?? 0,
      gamesOwned: data.steam_data.profile.games_count,
      totalHoursPlayed: data.steam_data.profile.total_hours,
      itemsOwned: data.steam_data.profile.items_count,
      inventoryPrice: data.steam_data.profile.inventory_price_usd,
      accountAge: differenceInCalendarYears(Date.now(), new Date(data.steam_data.profile.registration_date)),
      epic_token_value: data.user.epic_token_value,
      nextSteamUpdateUnlockDate: data.user.next_steam_update_unlocked,
      steam_update_in_progress: data.user.steam_update_in_progress,
      tokenValue: data.user.token_value,
      steamId: data.user.steam_id,
      ref_url: data.user.ref_url,
      ref_url_story: data.user.ref_url_story,
      gamed_premium_until: data.user.gamed_premium_until,
      level_premium: data.user.level_premium,
      favoriteGame: null,

      diff_games_count: data.steam_data.profile.diff_games_count,
      diff_total_hours: data.steam_data.profile.diff_total_hours,
      diff_items_count: data.steam_data.profile.diff_items_count,
      diff_total_value_usd: data.steam_data.profile.diff_total_value_usd,

      profile_private: data.steam_data.profile.privacy_info.profile_private,
      previous_token_value_total: data.user.previous_token_value_total,
      registredAt: data.steam_data.profile.registration_date,
      gigi_index: data.user.gigi_index,
      farcana_gigi: data.user.farcana_gigi,

      epic_id: data.user.epic_id,
      epic_update_in_progress: data.user.epic_update_in_progress,
      next_epic_update_unlocked: data.user.next_epic_update_unlocked,
    },
    scoring_diff: data.steam_data.scoring_diff,
    referal_info: data.referral_info,
    settings: data.settings,
  }

  return steamUserData
}

export { useSteamDataResponse }
